import equipment from './equipment';
import widgetInfo from './widgetInfo';

const root = {
	equipment,
	widgetInfo
};

export default root;



// WEBPACK FOOTER //
// ./src/reducers/index.js